import { render, staticRenderFns } from "./ConsumerDetail.vue?vue&type=template&id=064f20b2"
import script from "./ConsumerDetail.vue?vue&type=script&lang=ts"
export * from "./ConsumerDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports